import React, { useEffect, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { eventuallyInsertPaypalScript } from "../utility/paypal";
import classNames from "classnames";

const PaypalPlacement = ({ clientId, sellingPrice }) => {
  const containerRef = useRef();
  const [paypalLoaded, setPaypalLoaded] = useState();

  const {
    site: { siteMetadata },
  } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            priceLanguage
          }
        }
      }
    `
  );

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const paypalPlacement = document.createElement("div");
      paypalPlacement.setAttribute("data-pp-message", "");
      paypalPlacement.setAttribute("data-pp-style-layout", "text");
      paypalPlacement.setAttribute("data-pp-style-logo-type", "inline");
      paypalPlacement.setAttribute("data-pp-style-text-color", "black");
      paypalPlacement.setAttribute("data-pp-style-text-size", "14");
      paypalPlacement.setAttribute("data-pp-style-logo-position", "left");
      paypalPlacement.setAttribute("data-pp-style-color", "gray");
      paypalPlacement.setAttribute("data-pp-amount", sellingPrice);
      paypalPlacement.setAttribute("data-pp-placement", "product");
      eventuallyInsertPaypalScript(clientId);

      const activationPaypalScript = new MutationObserver(function () {
        if (paypalPlacement.childNodes.length > 0) {
          setPaypalLoaded(true);
        }
      });
      activationPaypalScript.observe(paypalPlacement, {
        childList: true,
      });
      container.appendChild(paypalPlacement);
      return () => {
        activationPaypalScript.disconnect();
        container.removeChild(paypalPlacement);
      };
    }
  }, [sellingPrice, clientId, siteMetadata.priceLanguage]);

  return (
    <div
      className={classNames(paypalLoaded ? "paypal-active" : "paypal-inactive")}
      ref={containerRef}
    ></div>
  );
};

export default React.memo(PaypalPlacement);
